const createSessionSelectOptionsData = (sessions) => {
    if (!sessions || !Array.isArray(sessions)) return [];
    return sessions.map((session) => ({
        text: `${new Date(session.startDate).getFullYear()} (${session.type.charAt(0) + session.type.slice(1).toLowerCase()})`,
        value: session.id
    }));
};

export { createSessionSelectOptionsData };
